import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UserHubNotification } from '@models/notification.model';

@Component({
  selector: 'app-notifications-user-actions-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="actions-container">
      <button class="actionButton" id="viewBtn" mat-mini-fab data-action="view" title="View">
        <mat-icon data-action="view">visibility</mat-icon>
      </button>
      <button *ngIf="!isRead" class="actionButton" id="markReadBtn" mat-mini-fab data-action="markRead" title="Mark as Read">
        <mat-icon data-action="markRead">mark_email_read</mat-icon>
      </button>
      <button *ngIf="isRead" class="actionButton" id="markUnreadBtn" mat-mini-fab data-action="markUnread" title="Mark as Unread">
        <mat-icon data-action="markUnread">mark_email_unread</mat-icon>
      </button>
    </div>
  `,
  styles: [`
    .actions-container {
      display: flex;
      justify-content: center;
    }
    .actionButton {
      margin: 2px;
      cursor: pointer;
    }
    #viewBtn { background-color: #0099ab; color: white; }
    #markReadBtn { background-color: #0099ab; color: white; }
    #markUnreadBtn { background-color: #0099ab; color: white; }
  `]
})
export class NotificationsUserActionsRendererComponent implements ICellRendererAngularComp {
  isRead = false;

  agInit(params: ICellRendererParams): void {
    const notification = params.data as UserHubNotification;
    this.isRead = notification?.isRead ?? false;
  }

  refresh(params: ICellRendererParams): boolean {
    const notification = params.data as UserHubNotification;
    this.isRead = notification?.isRead ?? false;
    return true;
  }
}
